var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { Provider } from 'react-redux';
import PricingGridComponent from './PricingGridComponent';
import configureStore from './reducers/configureStoreReducer';
import Logger from './logger/logger';
import PropTypes from 'prop-types'; // Create a Redux store holding the state of your app.
// Its API is { subscribe, dispatch, getState }.

var store = configureStore(); // eslint-disable-next-line react/prefer-stateless-function

var PricingGrid =
/** @class */
function (_super) {
  __extends(PricingGrid, _super);

  function PricingGrid(props) {
    var _this = _super.call(this, props) || this;

    _this.componentDidCatch = function (error, info) {
      _this.logger.logError({
        message: 'Error occurred in PricingGrid Error Boundary',
        error: {
          errorInfo: error,
          info: info
        }
      }, 'pricingGrid');
    };

    _this.logger = new Logger(props.onGetAccessToken);
    return _this;
  }

  PricingGrid.prototype.render = function () {
    return React.createElement(Provider, {
      store: store
    }, React.createElement(PricingGridComponent, __assign({}, this.props)));
  };

  PricingGrid.propTypes = {
    onGetAccessToken: PropTypes.func,
    parentService: PropTypes.string,
    selectedRow: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    }),
    selectedColumn: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  };
  PricingGrid.defaultProps = {
    onGetAccessToken: function onGetAccessToken() {
      return {};
    },
    parentService: 'priceExplorer',
    selectedRow: {
      key: 'Quantity',
      value: 'Quantity'
    },
    selectedColumn: null
  };
  return PricingGrid;
}(React.Component);

export default PricingGrid;